export default "__VITE_ASSET__Brbr1mSW__"